<div style="padding-bottom: 50px;">
  <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
  <div class="d-flex align-items-center justify-content-center">
    <section class="alternative-section">
      <div class="alternative-container">

        <div class="alternative-header">
          <img [src]="'assets/svg/alter-prod/light-bub.svg'" alt="light-bub-icon" class="object-fit-contain"
            style="width: 24px; height: 24px;"  loading="lazy" />
          <span class="header-txt">Sản phẩm thay thế {{nameOfMainProduct}}</span>
        </div>

        <div class="alternative-body">

          <ng-container *ngIf="skeletonLoader">
            <app-skeleton-product-box *ngFor="let item of skeletonItems"></app-skeleton-product-box>
          </ng-container>

          <ng-container *ngIf="!skeletonLoader && alterProducts?.length > 0">
            <app-product-box *ngFor="let product of alterProducts" [product]="product" [isListView]="isListView"
              [class]="'product-box-3'" [style]="'horizontal'" (productLabel)="queryStringBuilder($event)">
            </app-product-box>
          </ng-container>

        </div>
      </div>
    </section>
  </div>
</div>